/**
 * PlatformModule (core) — coordinador de los 3 submódulos de plataforma:
 *   - platform-nodos.js          árbol fractal de nodos.
 *   - platform-administradores.js usuarios admin.
 *   - platform-dispositivos.js    POS/screens/cajas.
 *
 * Contiene SOLO estado compartido entre submódulos (caches + flags de
 * comunicación inter-módulo). La lógica de cada dominio vive en su propio
 * archivo. Los submódulos se autorregistran al cargar.
 */

export const PlatformModule = {
    // ─── Caches globales compartidos entre submódulos ──────────────────
    cachedPuntosVenta: [],

    // ─── Flags inter-módulo (modal Dispositivo ↔ creación inline Nodo) ─
    _dispositivoNodoSearchInput: null,
    _creatingNodoFromDispositivo: false,
    _dispositivoIdBeforeInlineCreate: null,
    _dispositivoCodigoBeforeInlineCreate: null,

    init() {
        // Submódulos se autorregistran al cargar — nada que inicializar.
    },
};
